import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  error: false,
  errorContent: null,
  loading: false,
  isLogin: false,
  register: null,
  recieveCode: false,
  phoneLogin: null,
  logOrRegister: true,
}
export const loginSlice = createSlice({
  name: 'login',
  initialState: initialState,
  reducers: {
    setPhone: (state, { payload }) => {
      state.phoneLogin = payload
    },
    setTologOrRegister: (state, { payload }) => {
      state.logOrRegister = payload
    },
    loginLoading: (state) => {
      state.loading = true
    },
    loginSuccess: ( state, action ) => {
      state.loading = false
      state.user = action.payload.user
      state.error = false
      state.errorContent = null
      state.isLogin = true
    },
    loginData: (state, {payload}) => {
      state.user = payload
      state.isLogin = true
    },
    logout: (state) => {
      return initialState
    },
    getRegisterStatus: (state, { payload }) => {
      state.register = payload
    },
    registerData: (state, { payload }) => {
      state.register = payload
      state.recieveCode = true
    },
    cancelRegister: (state) => {
      return initialState
    }
  }
  
})

export const { loginLoading, loginSuccess, logout, setTologOrRegister, loginData, getRegisterStatus, registerData, setPhone, cancelRegister } = loginSlice.actions
// export default signUp.reducer